import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlRemuneracaoADMRH = '/service/contabilidade/transparencia/admrh/'
class consultaRemuneracaoADMRHService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro, tipoServidor) {
        let data = {
            referencia: filtro.referencia,
            matricula: filtro.matricula ? filtro.matricula : '',
            cargo: filtro.cargo ? filtro.cargo.value : '',
            tiposervidor: tipoServidor,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'remuneracao/', JSON.stringify(data))
    }

    consultarQuadrosMembros(filtro, tipoServidor) {
        let data = {
            referencia: filtro.referencia,
            tiposervidor: tipoServidor,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'quadroMembro/', JSON.stringify(data))
    }

    consultarQuadrosMembrosFgcc(filtro, tipoServidor) {
        let data = {
            referencia: filtro.referencia,
            tiposervidor: tipoServidor,
            fg_cc: 1,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'quadroMembro/', JSON.stringify(data))
    }

    consultarServidoresEmTeletrabalho(filtro, tipoServidor) {
        let data = {
            referencia: filtro.referencia,
            tiposervidor: tipoServidor,
            teletrabalho: 1,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'quadroMembro/', JSON.stringify(data))
    }

    consultarCargosComissao(filtro) {
        let data = {
            referencia: filtro.referencia,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'cargosCC/', JSON.stringify(data))
    }

    consultarCargosVagosOcupadosMembros(filtro, tipoServidor) {
        let data = {
            referencia: filtro.referencia,
            tiposervidor: tipoServidor,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'dadosCargosVagos/', JSON.stringify(data))
    }

    consultarConcurso(filtro) {
        let data = {
            referencia: filtro.referencia,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'concurso/', JSON.stringify(data))
    }

    consultarProvimentos(filtro, tipoServidor) {
        let data = {
            cargo: filtro.cargo ? filtro.cargo.value : '',
            tiposervidor: tipoServidor,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'dadosProvimentos/', JSON.stringify(data))
    }

    consultaVerbasIndenizatorias(filtro, tipoServidor) {
        let data = {
            cargo: filtro.cargo ? filtro.cargo.value : '',
            tiposervidor: tipoServidor,
            referencia: filtro.referencia ? filtro.referencia : '',
        }

        return this.conex.post(urlRemuneracaoADMRH + 'contrachequeVerbasInd/', JSON.stringify(data))
    }

    consultaVerbasExerciciosAnteriores(filtro, tipoServidor) {
        let data = {
            cargo: filtro.cargo ? filtro.cargo.value : '',
            tiposervidor: tipoServidor,
            referencia: filtro.referencia ? filtro.referencia : '',
        }

        return this.conex.post(urlRemuneracaoADMRH + 'contrachequeExercAnta/', JSON.stringify(data))
    }
    consultarVacancias(filtro, tipoServidor) {
        let data = {
            cargo: filtro.cargo ? filtro.cargo.value : '',
            tiposervidor: tipoServidor,
        }

        return this.conex.post(urlRemuneracaoADMRH + 'dadosVacancias/', JSON.stringify(data))
    }

    detalhesExperienciaProfissional(filtro) {
        let data = {
            matricula: filtro.matricula ? filtro.matricula : '',
        }

        return this.conex.post(urlRemuneracaoADMRH + 'dadosExperienciaProfissional/', JSON.stringify(data))
    }

    detalhesEscolaridadeCurriculos(filtro) {
        let data = {
            matricula: filtro.matricula ? filtro.matricula : '',
        }

        return this.conex.post(urlRemuneracaoADMRH + 'detalhesEscolaridadeCurriculos/', JSON.stringify(data))
    }
    consultarCurriculos(filtro) {
        let data = {
            cargo: filtro.cargo ? filtro.cargo.value : '',
        }

        return this.conex.post(urlRemuneracaoADMRH + 'dadosCurriculos/', JSON.stringify(data))
    }
}

export default consultaRemuneracaoADMRHService
